import React from "react";
import SysApiLogsList from "../component/SysApiLogList";

const SysApiLogsListContainer = () => (<SysApiLogsList />)

export default SysApiLogsListContainer;